import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import laptop from "../Components/images/z2.jpeg";
import logo1 from "../Components/images/logo1.jpeg";
import logo2 from "../Components/images/logo2.avif";
import logo3 from "../Components/images/logo3.avif";
import logo4 from "../Components/images/logo4.avif";
import logo5 from "../Components/images/logo5.avif";
import logo6 from "../Components/images/logo6.avif";
import logo7 from "../Components/images/logo7.avif";
import logo8 from "../Components/images/logo8.avif";
import logo9 from "../Components/images/logo9.avif";
import logo10 from "../Components/images/logo10.avif";
import logo11 from "../Components/images/logo1.webp";
import logo12 from "../Components/images/logo12.png";
import logo13 from "../Components/images/logo13.png";
import logo15 from "../Components/images/logo15.png";

import ser1 from "../Components/images/ser1.avif";
import ser2 from "../Components/images/ser2.avif";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Services() {
  return (


    <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-black text-white min-vh-100"
    
          
        >
    <div className="services-section bg-black text-white min-vh-100 py-5">
      <div className="container">
        <div className=" ">
          {/* Hero Section */}
          <div className="text-center " style={{ marginTop: "110px" }}>
            <h1 className="display-3 fw-bold anton ft2 mt-4">
              Google Ads That Deliver
              <br />
              <span className="text-warning2">Measurable Growth</span>
            </h1>

            <p className="text-secondary fs-5 mt-4">
              Ready to see real, targeted results? Our expertly crafted Google
              ad campaigns are designed to boost your brand’s visibility and
              drive growth.
            </p>
          </div>

          {/* Partners Section */}
          <div className="text-center mt-5 pt-3">
            <p className="text-secondary ">
              By collaborating with industry-leading partners, we ensure your
              brand gets the attention it deserves. Our tailored campaigns focus
              on maximizing ROI and delivering tangible business growth.
            </p>

            <div className="text-center mt-5 pt-3">
              <div className="logo-slider">
                <div className="slider-track">
                  <img src={logo11} alt="Shopify" />
                  <img src={logo2} alt="Ecomflows" />
                  <img src={logo3} alt="Partner 1" />
                  <img src={logo4} alt="Service Points" />
                  <img src={logo5} alt="Elysian Exit" />

                  <img src={logo6} alt="Shopify" />
                  <img src={logo7} alt="Ecomflows" />
                  <img src={logo8} alt="Partner 1" />
                  <img src={logo9} alt="Service Points" />
                  <img src={logo10} alt="Elysian Exit" />

                  <img src={logo12} alt="Elysian Exit" />
                  <img src={logo13} alt="Elysian Exit" />
                  <img src={logo11} alt="Shopify" />
                  <img src={logo2} alt="Ecomflows" />
                  <img src={logo3} alt="Partner 1" />
                  <img src={logo4} alt="Service Points" />
                  <img src={logo5} alt="Elysian Exit" />

                  <img src={logo6} alt="Shopify" />
                  <img src={logo7} alt="Ecomflows" />
                  <img src={logo8} alt="Partner 1" />
                  <img src={logo9} alt="Service Points" />
                  <img src={logo10} alt="Elysian Exit" />

                  <img src={logo12} alt="Elysian Exit" />
                  <img src={logo13} alt="Elysian Exit" />
                  <img src={logo11} alt="Shopify" />
                  <img src={logo2} alt="Ecomflows" />
                  <img src={logo3} alt="Partner 1" />
                  <img src={logo4} alt="Service Points" />
                  <img src={logo5} alt="Elysian Exit" />

                  <img src={logo6} alt="Shopify" />
                  <img src={logo7} alt="Ecomflows" />
                  <img src={logo8} alt="Partner 1" />
                  <img src={logo9} alt="Service Points" />
                  <img src={logo10} alt="Elysian Exit" />

                  <img src={logo12} alt="Elysian Exit" />
                  <img src={logo13} alt="Elysian Exit" />
                  <img src={logo11} alt="Shopify" />
                  <img src={logo2} alt="Ecomflows" />
                  <img src={logo3} alt="Partner 1" />
                  <img src={logo4} alt="Service Points" />
                  <img src={logo5} alt="Elysian Exit" />

                  <img src={logo6} alt="Shopify" />
                  <img src={logo7} alt="Ecomflows" />
                  <img src={logo8} alt="Partner 1" />
                  <img src={logo9} alt="Service Points" />
                  <img src={logo10} alt="Elysian Exit" />

                  <img src={logo12} alt="Elysian Exit" />
                  <img src={logo13} alt="Elysian Exit" />
                </div>
              </div>
            </div>
          </div>

          {/* Cards / Ads Section */}
          <div className="google-ads-section mt-5 ">
            <div className="row g-5">
              <div className="col-md-6 mb-4 mb-md-0 text-col">
                <h2 className="fw-bold text-white ftfl0  ">
                  Google Ads That Drive
                  <span className="text-warning">
                    {" "}
                    Explosive E-Commerce Growth
                  </span>
                </h2>

                <p className="text-secondary" >
                  At Dropshopi, we specialize in fueling dropshipping and D2C
                  brands with high-impact Google Ads campaigns that deliver real
                  results — no fluff, just growth.
                </p>

                <p className="text-secondary"  >
                  We combine data-driven strategies, creative execution, and
                  constant optimization to maximize ROAS at every stage of the
                  funnel. Whether you're launching your first winning product or
                  scaling to seven figures, our approach is designed for
                  sustainable, profitable growth. With full transparency and a
                  performance-first mindset, we act as an extension of your team
                  — not just another agency.
                </p>

                <h5 className="text-warning  mt-1 ftfl0 ghq1 mb-1">
                  What We Offer:
                </h5>
                <ul className="text-white ps-3 gapds">
                  <li>Proven Growth Strategy</li>
                  <li>Performance-Based Partnership </li>
                  <li>Proprietary Conversion Tools </li>
                  <li>24/7 Monitoring & Support </li>
                  <li>Real-Time Dashboards & Monthly Reports </li>
                  <li>Advanced Keyword & Audience Targeting </li>
                  <li>Exclusive Access to Our Network </li>
                </ul>
                <p>Ready to scale? Let’s make it happen.</p>
              </div>

              <div className="col-md-6  text-center">
                <div
                  className="img-container"
                  style={{ paddingBottom: "50px", height: '100%' }}
                >
                  <img
                    src={ser1}
                    alt="Laptop on table"
                    className="laptop-img img-fluid rounded mb-4"
                  />
                  <h5 className="display-3 fw-bold anton ft3 mt-4">
                    <span className="text-white ftfl0">
                      Growth That Pays for Itself –{" "}
                    </span>{" "}
                    <span className="text-warning">Our Promise to You</span>
                  </h5>
                  <p className="text-secondary fw-semibold">
                    We believe growth should pay for itself. That’s why we offer
                    a straightforward, performance-driven model:
                  </p>

                  <ul className="text-white ps-3">
                    {/* <li>One-Time Setup Fee: €400</li> */}
                    <li>Ongoing Fee: 8.5% of your revenue generated</li>
                  </ul>

                  <p>
                    This covers everything: strategy, campaign creation, and
                    continuous optimization.{" "}
                  </p>

                  <Link
                    to="/contact"
                    variant="primary"
                    className="btn-purple mb-5"
                  >
                    Book your free session!
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* card 2  */}
          <div className="strategic-partner-section bg-black text-white  mt-5">
            <Container>
              <div className="row  g-5">
                {/* Left Side: Image and Box */}
                <div className="col-md-6  text-center   ">
                  
                  <div className="image-container rounded-4" style={{height: '100%'}}>
                    <img
                      src={ser2}
                      alt="Strategic Offer"
                      className="img-fluid rounded-3 mb-1"
                    />

                    <div className="p-3">
                      <h3 className="fw-bold ftfl0">
                      Built for Businesses Ready to{" "}
                      <span className="text-warning"> Dominate Profitably</span>
                    </h3>
                    <p className="text-secondary mt-2">
                      For businesses consistently spending €30K+ per month on
                      ads and looking to scale fast, we offer a high-performance
                      solution.
                      <br />
                      Performance-Based Model starting at 3% of the revenue
                      generated, with discounted rates as your revenue grows
                      <br />
                      High spend deserves high performance — and we deliver
                      total accountability.
                    </p>
                    <Link to="/contact" className="btn-purple mb-5">
                      Book a Free strategy call
                    </Link>
                    </div>
                    
                  </div>
                </div>

                {/* Right Side: Text Content */}
                <div className="col-md-6 mb-4 mb-md-0 text-col ">
                  <h2 className="fw-bold mb-4 ftfl0">
                    Your Strategic Business Partner for Aggressive Growth
                  </h2>
                  <p className="text-secondary">
                    For brands ready to scale aggressively, we offer more than
                    just Google Ads. As your Strategic Business Partner, we
                    embed ourselves into your growth process — shaping your
                    offer, optimizing your funnel, and guiding key decisions
                    across marketing, operations, and CRO. This is for
                    e-commerce founders who don’t just want an agency, but a
                    team that thinks like a CMO and acts like your growth team.
                  </p>

                  <h5 className="text-warning fw-bold mt-4 ftfl0">
                    What's included?
                  </h5>
                  <ul className="text-white ps-3 ">
                    <li>Bi-Weekly Calls </li>
                    <li>Funnel Audits & Landing Page Guidance </li>
                    <li>Offer Refinement & Positioning Support </li>
                    <li>Cross-Channel Growth Strategy </li>
                    <li>Exclusive Access to Our Network </li>
                    <li>Budget Optimization </li>
                    <li>Detailed Performance Reporting & Insights </li>
                    <li>GMC Setup & Health Services </li>
                  </ul>
                </div>
              </div>
            </Container>
          </div>

          {/* strategey */}

          <div className="bg-black text-white py-4">
            <Container className="d-flex justify-content-center align-items-center ">
              <div className="box-container">
                <div className="strategy-card text-center px-2 py-2">
                  <h1 className="display-3 fw-bold anton ft1">
                    Ready to Experience Game-Changing Growth?
                    <br />
                    Put Our{" "}
                    <span className="text-warning">NEXT LEVEL STRATEGY </span>to
                    the Test
                  </h1>

                  <p className="text-secondary mt-4 fs-5 fw-medium">
                    <span className="text-warning">
                      {" "}
                      Limited Spots Available -{" "}
                    </span>{" "}
                    We only work with entrepreneurs who
                    <br /> are ready to <strong>scale and maximise ROAS</strong>
                    . Don’t miss this
                    <br /> opportunity – book your session today!
                  </p>

                  <Button variant="primary" className="  btn-purple">
                    Book Your Free Strategic Call
                  </Button>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </div>
    </motion.div>
  );
}
